import { ThunkDispatch } from "redux-thunk";
import { AppState } from "../types/state/AppState";
import { useDispatch } from "react-redux";
import { UnknownAction } from "redux";

export type AppDispatch = ThunkDispatch<AppState, any, UnknownAction>;

export const useAppDispatch = () => useDispatch() as AppDispatch